import { List, ListItem, ListItemText, Popover } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface ScrollableListPopoverProps<T> {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  data: T[];
  onItemClick?: (item: T) => void;
  getPrimaryText: (item: T) => string;
  getSecondaryText?: (item: T) => string;
  enableDarkTheme?: boolean;
  width?: number;
  height?: number;
}

export function ScrollableListPopover<T>({
  open,
  anchorEl,
  onClose,
  data,
  getPrimaryText,
  getSecondaryText,
  enableDarkTheme = false,
  width = 300,
  height = 300,
  onItemClick,
}: ScrollableListPopoverProps<T>) {
  const handleItemClick = (item: T) => {
    if (onItemClick) {
      onItemClick(item);
      onClose();
    }
  };

  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      PaperProps={{
        sx: {
          maxHeight: height,
          width,
          overflowY: 'auto',
          backgroundColor: enableDarkTheme
            ? palette.pageBackground
            : palette.pageBackground,
        },
      }}
    >
      <List dense>
        {data?.map((item, index) => (
          <ListItem
            key={index}
            sx={{ padding: '0px 8px' }}
            onClick={() => {
              handleItemClick(item);
            }}
          >
            <ListItemText
              primary={getPrimaryText(item)}
              secondary={getSecondaryText?.(item)}
              primaryTypographyProps={{
                color: palette.textPrimary,
              }}
              secondaryTypographyProps={{
                color: enableDarkTheme
                  ? ThemePalette.typography.grey
                  : ThemePalette.typography.black,
                fontSize: '11px',
              }}
            />
          </ListItem>
        ))}
      </List>
    </Popover>
  );
}
